module.exports = __webpack_public_path__ + "img/Feature.9fb0162c.jpg";